import {
  IonToolbar as IonicIonToolbar,
  IonAvatar as IonicIonAvatar,
} from '@ionic/react'
import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const ModalImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    object-fit: contain;
    height: 100vh;
  }
`

export const IonToolbarFooter = styled(IonicIonToolbar)`
  --background: ${myPalette.aliceBlue.main};
  --border-width: 0 !important;
  --padding-end: 0;
  --padding-start: 0;
  --padding-bottom: 0;
  --padding-top: 0px;
  --box-shadow: none;
`

export const IonAvatar = styled(IonicIonAvatar)`
  display: flex;
  align-items: center;
  justify-content: center;
`
